<script>
    export let result;
</script>

<div>
    <a style="text-decoration: none" href={result.external_url} target="_blank">
        <div class="result-bit">{result.item_title}</div>
        <div class="result-bit">{result.authors}</div>
        <div class="result-bit">{result.date_published}</div>
        <div class="result-bit">{result.publication_name}</div>
    </a>
</div>


<style>
    .result-bit {
        font-size: .8em;
    }
</style>
